export default __webpack_public_path__ + "static/purrnelopescountryclub-462e03db927948db6121ab179ddf11b8.jpg";